import ChatService from '@/services/API/ChatService';

export const getNotificationsLessons = (courseId, courseUnitId, lessons) => {
  // backend not provided one method for all lessons scoope
  const promises = lessons.map((i) => ChatService.getUnreadConsultationsByTag({
    course_id: courseId,
    course_unit_id: courseUnitId,
    lesson_id: i.id,
  }).then((resp) => ({ id: i.id, hasMessages: resp.data.data })));

  return Promise.all(promises);
};

export const getNotificationsByItem = (lessons) => {
  // backend not provided one method for all lessons scoope
  const promises = lessons.map((i) => ChatService.getUnreadConsultationsByTag({
    course_id: i.course.id,
    course_unit_id: i?.unit?.id,
    lesson_id: i?.lesson?.id,
  }).then((resp) => {
    i.hasMessages = resp.data.data;
    return i;
  }));

  return Promise.all(promises);
};
